<div class="container card-height">
    <carousel [slides]="slides" [animationType]="animationType"></carousel>
    <div class="animition-type-selector">
        <!-- <div
          *ngFor="let type of animationTypes"
          class="button"
          (click)="setAnimationType(type)"
          [class.active]="animationType === type.value"
        >
          {{ type.name }}
        </div> -->
    </div>
</div>

<div class="content--compact" style="padding-top: 10px;background-color:#252525;">
    <div class="about-img"><img _ngcontent-c3="" class="news__image" src="/assets/img/blog/card_display_2023.png" style="width:100%;"></div>
    <div class="about-sec">
        <h2>About us</h2>
        <p style="font-family:'d35';font-size:25px; line-height:30px;font-weight: normal;padding-top:30px;padding-right:20px;margin-bottom:12px;">
            Since 1998, SGC has been a well-established leader in the authentication and grading of trading cards. Our ability to provide accurate and consistent grades in a timely manner is a service that is unique to the card-collecting community and has made SGC one of the pillars of card grading for over 25 years. As our hobby continues to grow, SGC’s mission remains the same – to provide the best grading experience for all collectors.
        </p>
        <!--<a routerLink="/aboutus" class="more" >READ MORE</a>-->
    </div>
</div>

<!-- <h2 style="color:#ffffff;text-align:center;background-color:#252525;padding-top:100px; float:left; width:100%; margin-bottom:3px;">NEWS</h2>
<section class="services pd-top revised-services">

    <div class="services__item" style="padding:1.5%;">
        <div class="services__item-title">
            <img alt="SGC is a proud partner of the Miami Dolphins" [src]="article" style="width: 100%;">
        </div>
        <p style="color:#ffffff;font-size:19px; line-height:26px;font-weight: normal;">
            SGC has officially kicked off a multi-year partnership with the Miami Dolphins!
            <a routerLink="/SGC-x-MiamiDolphins" class="more">Read More</a>
        </p>
    </div>

    <div class="services__item" style="padding:1.5%;">
        <div class="services__item-title">
            <img alt="SGC Joins Collectors" [src]="readmore" style="width: 100%;">
        </div>
        <p style="color:#ffffff;font-size:19px; line-height:26px;font-weight: normal;">
            Collectors has announced the acquisition of SGC. Building on a legacy of more than 25 years, SGC will continue to operate independently within the Collectors portfolio, led by its existing management team.
            <a routerLink="/SGC-Joins-Collectors" class="more">Read More</a>
        </p>
    </div>

    <div class="services__item" style="padding:1.5%;">
        <div class="services__item-title">
            <img alt="Download the SGC App Today!" [src]="download" style="width: 100%;">
        </div>
        <p style="color:#ffffff;font-size:19px; line-height:26px;font-weight: normal;">
            The SGC mobile app is available for download in the Apple and Google Play Stores! Create and track submissions. Easily access Cert Code and Pop Report data. Build, manage, and enjoy your SGC collection!
            <a routerLink="/sgc-grading-app" class="more">Download App</a>
        </p>
    </div>

</section> -->



<div class="container_2" style="background:#252525;">
    <h2 style="color:#ffffff;margin-bottom:-20px; float:left; text-align:center;width:100%; margin-top: 40px;">Recent Posts</h2>
    <iframe scrolling="no" src="https://widget.taggbox.com/76864" style="width:100%;min-height: 800px;border:none;margin-top: -100px;"></iframe>
</div>

<div style="margin-top:-73px;"></div>
